import i18next from 'i18next';
import { memo, useCallback, useId } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  closeMultiStorePanel,
  openMultiStorePanel,
  selectedIsMultiStorePanelOpen,
} from '../../../../store/multi-store';
import { joinNames } from '../../../../utils/multi-store/text';
import { MultiStorePanel } from './multi-store-panel';
import { MultiStoreRecapRow } from './multi-store-recap-row';
import { trackMultiStorePanelOpened } from './multi-store-tracking';
import { useIncludedCenters } from './use-multi-store';

// Sopra il calendario unificato: in quali centri si sta cercando, su una riga sola.
// «Modifica» apre il pannello dei centri subito sotto la riga.
export const MultiStoreSummary = memo(
  function MultiStoreSummary(): JSX.Element {
    const dispatch = useAppDispatch();
    const centers = useIncludedCenters();
    const isPanelOpen = useAppSelector(selectedIsMultiStorePanelOpen);
    const panelId = useId();

    const text = i18next.t('pages.when.multi_store.summary', {
      count: centers.length,
      names: joinNames(
        centers.map((center) => center.pointOfSale.name),
        i18next.t('pages.when.multi_store.and')
      ),
    });

    const handleToggle = useCallback(() => {
      if (isPanelOpen) {
        dispatch(closeMultiStorePanel());
        return;
      }
      dispatch(openMultiStorePanel());
      trackMultiStorePanelOpened();
    }, [dispatch, isPanelOpen]);

    return (
      <>
        <MultiStoreRecapRow
          text={text}
          actionText={i18next.t('pages.when.multi_store.summary_action')}
          isExpanded={isPanelOpen}
          panelId={panelId}
          isTruncated
          onAction={handleToggle}
        />
        {isPanelOpen && <MultiStorePanel id={panelId} />}
      </>
    );
  }
);
